import { CveMatchResult } from "@/services/appCveMatcher";
import { NvdCveData } from "@/services/nvdApi";

export interface PerVersionSortEntry {
  r: CveMatchResult;
  counts: Record<NvdCveData["severity"], number>;
}

export function buildPerVersionEntries(perVersion: CveMatchResult[]): PerVersionSortEntry[] {
  return perVersion
    .filter((r) => r.cves.length > 0)
    .map((r) => {
      const counts: Record<NvdCveData["severity"], number> = {
        CRITICAL: 0,
        HIGH: 0,
        MEDIUM: 0,
        LOW: 0,
        NONE: 0,
      };
      r.cves.forEach((c) => {
        counts[c.severity]++;
      });
      return { r, counts };
    });
}

export type PerVersionSortMode = "severity" | "total";

/**
 * Sort per-version entries.
 * - "severity": Critical desc → High desc → Medium desc → Low desc → total CVE count desc.
 * - "total": total CVE count desc → Critical desc → High desc as tiebreakers.
 */
export function sortPerVersionEntries(
  entries: PerVersionSortEntry[],
  mode: PerVersionSortMode = "severity",
): PerVersionSortEntry[] {
  return [...entries].sort((a, b) => {
    if (mode === "total") {
      if (b.r.cves.length !== a.r.cves.length) return b.r.cves.length - a.r.cves.length;
      if (b.counts.CRITICAL !== a.counts.CRITICAL) return b.counts.CRITICAL - a.counts.CRITICAL;
      if (b.counts.HIGH !== a.counts.HIGH) return b.counts.HIGH - a.counts.HIGH;
      return 0;
    }
    if (b.counts.CRITICAL !== a.counts.CRITICAL) return b.counts.CRITICAL - a.counts.CRITICAL;
    if (b.counts.HIGH !== a.counts.HIGH) return b.counts.HIGH - a.counts.HIGH;
    if (b.counts.MEDIUM !== a.counts.MEDIUM) return b.counts.MEDIUM - a.counts.MEDIUM;
    if (b.counts.LOW !== a.counts.LOW) return b.counts.LOW - a.counts.LOW;
    return b.r.cves.length - a.r.cves.length;
  });
}
